import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@util/helpers";

/** Input field - submit button */
const SubmitButton = ({
  label,
  variantClassName,
  isSubmitting,
}: SubmitButtonFields): React.ReactElement => {
  return (
    <ButtonFactory
      buttonType={ButtonType.Primary}
      type="submit"
      className={cn(
        "relative w-full place-self-center px-[100px] py-6 text-base font-semibold leading-150 tracking-2 lg:w-auto",
        variantClassName?.container,
        {
          "pointer-events-none": isSubmitting,
        }
      )}
      text={label}
    >
      {isSubmitting ? (
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <FontAwesomeIcon
            icon={faSpinner}
            spin
            size="sm"
            className="text-white"
          />
        </div>
      ) : null}

      <span
        className={cn("transition-opacity duration-150", {
          "opacity-0": isSubmitting,
        })}
      >
        {label}
      </span>
    </ButtonFactory>
  );
};

export default SubmitButton;
